import React, { useEffect, useState } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import { InputField, Submitbtn } from "../../../Component";
import {
  deleteProductType,
  getProductTypeList,
  updateProductType,
  uploadProductTypeImage,
} from "../adminSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import LabelInput from "../../../Component/labelInput";
import { validateAgeGrp, validateIsFileImageType } from "../../../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";

const EditDeleteProductType = () => {
  const [isEditMode, setisEditMode] = useState<Boolean>(false);
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productName, setProductName] = useState<any>("");
  const [order, setOrder] = useState<any>("");
  const [ProductImage, setProductImage] = useState<any>("");
  const [ProductImagePreview, setProductImagePreview] = useState<any>("");
  const [seoName, setseoName] = useState<any>("");
  const [productTypeId, setproductTypeId] = useState<any>("");
  const [editProductValue, setEditProducValue] = useState<any>();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
          if (res?.status === "success") {
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };
  const onchangeProductName = (value: any) => {
    setProductName(value);
    // if (validateAgeGrp(value)) {
    // setProductName(value);}
  };
  const onchangeOrder = (value: any) => {
    setOrder(value);
    // if (validateAgeGrp(value)) {
    //   setOrder(value);
    // }
  };
  const onchangeProductImg = (e: any) => {
    e.preventDefault();
    const mediaTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    const reader = new FileReader();
    const file = e.target.files[0];
    if (!mediaTypes.includes(file.type)) {
      console.error("Unsupported file type:", file.type);
      return;
    }
    reader.onloadend = () => {
      setProductImagePreview(reader.result)
      setProductImage(file);
    };
    reader.readAsDataURL(file);
    dispatch(
      uploadProductTypeImage({
        params: file,
        callback: (res: any) => {
          if (res?.status === "success") {
            setProductImage(res?.data?.name);
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };

  const onchangeSeoName = (value: any) => {
    setseoName(value);
  };
  const onUpdateProductType = (image: any) => {
    const postData: any = {};
    if (productTypeList?.name !== productName) {
      postData["name"] = productName;
    }
    if (productTypeList?.order !== order) {
      postData["order"] = order;
    }
    if (productTypeList?.image !== image) {
      postData["image"] = image;
    }
    if (productTypeList?.seoName !== seoName) {
      postData["seoName"] = seoName;
    }
    dispatch(
      updateProductType({
        id: productTypeId,
        params: postData,
        callback: (res: any) => {
          setisEditMode(false);
          getData();
          if (res?.data?.status === "success") {
            dispatch(showSnackbar({ message: res?.data?.msg, type: res?.data?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };
 
  const handleEdit = (value: any) => {
    setEditProducValue(value);
    setisEditMode(true);
    setproductTypeId(value._id);
    setProductName(value.name);
    setOrder(value.order);
    setProductImage(value.image);
    setseoName(value.seoName);
  };
  const handleDelete = (value: any) => {
    setisEditMode(false);
    dispatch(
      deleteProductType({
        id: value._id,
        callback: (res: any) => {
          if (res?.status === "success") {
            getData();
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);

        },
      })
    );
  };

  const validations = () => {
    return (
      productName === "" ||
      order === "" ||
      // ProductImage === "" ||
      seoName === ""
    );
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData: any = {};
    if (editProductValue?.name !== productName) {
      postData["name"] = productName;
    }
    if (editProductValue?.order !== order) {
      postData["order"] = order;
    }
    if (editProductValue?.image !== ProductImage) {
      postData["image"] = ProductImage;
    }
    if (editProductValue?.seoName !== seoName) {
      postData["seoName"] = seoName;
    }
    dispatch(
      updateProductType({
        id: productTypeId,
        params: postData,
        callback: (res: any) => {
          setisEditMode(false);
          getData();
          if (res?.data?.status === "success") {
            dispatch(showSnackbar({ message: res?.data?.msg, type: res?.data?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
            setisEditMode(false);
            setProductName("");
            setOrder("");
            setProductImage("");
            setProductImagePreview("");
            setseoName("");
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );

  };
  const renderTable = () => {
    return (
      <AdminTable
        tableData={productTypeList ? productTypeList : []}
        pagename={"ProductType"}
        tableHead={["S.N", "Name", "Order No.", "Seo Name", "Action"]}
        handleEdit={(value: any) => handleEdit(value)}
        handleDelete={(value: any) => handleDelete(value)}
        edit={true}
      />
    );
  };
  const renderEditMode = () => {
    return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-3 mb-3 ">
            <LabelInput labelName={"Product Type"} />
            <InputField
              key={"ex2"}
              placeholder={"Enter Product Type"}
              setInputText={(value: any) => onchangeProductName(value)}
              value={productName}
            />
          </div>
          <div className="col-md-3 mb-3">
            <LabelInput labelName={"Order number"} />
            <InputField
              key={"ex2"}
              placeholder={"Order  No"}
              setInputText={(value: any) => onchangeOrder(value)}
              value={order}
              maxLength={3}
            />
          </div>
          <div className="col-md-3 mb-3">
            <LabelInput labelName={"SEO Name"} />
            <InputField
              key={"ex2"}
              placeholder={"Enter SEO Name"}
              setInputText={(value: any) => onchangeSeoName(value)}
              value={seoName}
            />
          </div>
          <div className="col-md-3 mb-3">
            <LabelInput labelName={"Upload Image"} />
            <ImagePickerAndViewer
              value={ProductImagePreview ? ProductImagePreview : ProductImage}
              handleChange={(value: any) => onchangeProductImg(value)}
              htmlFor={`photo-upload-product`}
              doctype={""}
            />
          </div>
          <div className="d-flex justify-content-center mt-3">
            <div className="col-2 pt-2">
              <Submitbtn name={"UPDATE"} disabled={validations()} />
            </div>
          </div>
        </div>
      </form>
    );
  };
  const handleGoBack = () => {
    setisEditMode(false);
  };

  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete Product Type"}
          breadCrumb={""}
          isEditMode={isEditMode}
          setisEditMode={setisEditMode}
          cancelEdit={() => handleGoBack()}

        />
      </div>
      <div className="formDiv ">
        <div className="bxshadow p-2 borderRadius">
          {isEditMode ? renderEditMode() : renderTable()}
        </div>
      </div>
    </div>
  );
};

export default EditDeleteProductType;
